import { render, staticRenderFns } from "./roomAdd.vue?vue&type=template&id=c19878ca&scoped=true&"
import script from "./roomAdd.vue?vue&type=script&lang=js&"
export * from "./roomAdd.vue?vue&type=script&lang=js&"
import style0 from "./roomAdd.vue?vue&type=style&index=0&id=c19878ca&scoped=true&lang=css&"
import style1 from "./roomAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19878ca",
  null
  
)

export default component.exports